export const API_BASE_URL = "/api";

export const AUTH_URL = API_BASE_URL;

export const formatUrl = (url: string, params: Record<string, string>) =>
  Object.keys(params).reduce((url, key) => url.replace(`:${key}`, params[key]), url);
